import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { EmployeeAgreementTemplateComponent } from './employee-agreement-template.component';
import { EmployeeAgreementTemplateRouting } from './employee-agreement-template-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MyDatePickerModule } from 'mydatepicker';
import { NgSelectModule } from '@ng-select/ng-select';
import { SignaturePadModule } from 'angular2-signaturepad';
import { EmployeeAgreementTemplateService } from './employee-agreement-template.service';
import { PDFExportModule } from '@progress/kendo-angular-pdf-export';


@NgModule({
  declarations: [EmployeeAgreementTemplateComponent],
  imports: [
    CommonModule, 
    EmployeeAgreementTemplateRouting,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    MyDatePickerModule,    
    SignaturePadModule,
    PDFExportModule
  ],
  
 exports:[EmployeeAgreementTemplateComponent],
 providers:[DatePipe,EmployeeAgreementTemplateService],
 schemas:[CUSTOM_ELEMENTS_SCHEMA]
})
export class EmployeeAgreementTemplateModule { }